import { getSeasonById } from '~/helpers/ladder';
import { getRank } from '~/roles';
import { currentRoleNameSelector, currentClanIdSelector } from '~/store/selectors/currentAccountSelector';
import { createAppSelector } from '~/store/utils/createSelector';

import type { RootState } from '~/store';

const defaultSort = Object.freeze({
  field: 'name',
  isAsc: true,
});

const membersSelector = (state: RootState) => {
  return state.members.clans || {};
};

export const currentClanMembersSelector = createAppSelector(
  [currentClanIdSelector, membersSelector],
  (currentClanId, members) => {
    if (!currentClanId) {
      return [];
    }

    return members[currentClanId]?.members || [];
  },
);

export const clanMembersSelector = createAppSelector(
  [membersSelector, (_: RootState, clanId: number) => clanId],
  (members, clanId) => {
    return members[clanId]?.members || [];
  },
);

export const selectedMemberIdsSelector = (state: RootState) => state.membersOperation.selectedIds;

export const clanMembersStatisticsSelector = (state: RootState, clanId: number) => {
  return state.members.statistics[clanId];
};

export const clanMembersIsFetchingSelector = (state: RootState, clanId: number) => {
  return state.members.isFetching[clanId];
};

export const membersBattleTypesSelector = (state: RootState, clanId: number) => {
  return state.members.battleTypes[clanId];
};

export const membersTeamNumberSelector = (state: RootState, clanId: number) => {
  return state.members.teamNumber[clanId];
};

const membersCurrentSeasonSelector = (state: RootState) => state.members.currentSeason;

export const membersCurrentSeasonDataSelector = createAppSelector(membersCurrentSeasonSelector, (currentSeason) => {
  return {
    currentSeason,
    currentSeasonType: getSeasonById(currentSeason)?.kind,
  };
});
const clanIdSelector = (_: RootState, clanId: number) => clanId;

const clanEntrySelector = createAppSelector(
  [(state: RootState) => state.members.clans, clanIdSelector],
  (clans, clanId) => clans[clanId],
);

export const clanMembersErrorSelector = createAppSelector([clanEntrySelector], (clanEntry) => {
  return clanEntry?.error ?? '';
});

export const clanMembersSortSelector = createAppSelector([clanEntrySelector], (clanEntry) => {
  return clanEntry?.sort ?? defaultSort;
});

export const disabledIdsSelector = createAppSelector(
  clanMembersSelector,
  currentRoleNameSelector,
  (members, currentRoleName) => {
    return members
      .filter((member) => {
        if (!currentRoleName) {
          return false;
        }
        return getRank(member.roleName) >= getRank(currentRoleName);
      })
      .map((member) => member.id);
  },
);
